import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FacilityAccess } from 'src/app/models/facility/facility-access.model';

@Component({
    selector: 'app-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    styleUrls: ['./sidebar-menu.component.scss'],
    standalone: false
})

export class SidebarMenuComponent {
  @Input() public menuItems: any[] = [];
  @Input() public facilities: FacilityAccess[];
  @Input() public selectedFacility: FacilityAccess;
  @Input() public isFacilityAdmin: boolean;
  @Output() public facilityChange = new EventEmitter<FacilityAccess>();

  constructor(
  ) { }

  public changeFacility(): void {
    this.facilityChange.emit(this.selectedFacility);
  }

  public showMenuItem(menuItem: any): boolean {
    switch (menuItem.title) {
      case 'Home':
        return true;
      case 'Site Management':
        return this.isFacilityAdmin;
      default:
        return this.facilities?.length > 0;
    }
  }

  public showSubMenuItem(childItem: any): boolean {
    switch (childItem.title) {
      case 'Roles & Permissions':
        return this.isFacilityAdmin;
      default:
        return true;
    }
  }

  public disableSubMenuItem(childItem: any): boolean {
    switch (childItem.title) {
      case 'Add New Resident':
        return !(this.isFacilityAdmin || this.selectedFacility.accessLevel === 'WRITE');
      default:
        return false;
    }
  }
}
